<template>
  <div style="background-color: lightgray">
    <van-row gutter="0" style="background-color: white">
      <van-col span="24">
        <div style="color: #44b1eb;margin: 2%;text-indent: 2em;font-size: smaller">
          <div>
            根据国家网信办规定，平台进行实名安全工作，当你的账户出现风险时，在必要时系统会要求您进行更高级别的认证。
            <div>
            我们承诺保障您的资金安全，且不会泄露您的个人隐私，请你积极配合。
            </div>
          </div>
        </div>
      </van-col>
    </van-row>
    <van-form>
      <van-row gutter="0">
      <van-col span="24">
        <div style="min-height: 44px;line-height: 44px;color: darkgray;margin-top: 2%;font-size: smaller">
          <span style="margin-left: 5%;">填写身份证信息({{customer.isReviewPass?"审核通过":"待提交"}})</span>
        </div>
      </van-col>
    </van-row>
      <van-row gutter="0" style="background-color: white">
        <van-col span="24">
          <van-row gutter="0">
            <van-col span="24">
              <van-field
              v-model="customer.username"
              placeholder="身份证姓名"
              :rules="[{ required: true, message: '请填身份证姓名' }]"
              :readonly="customer.isReviewPass">
              </van-field>
            </van-col>
          </van-row>
          <van-row gutter="0" v-if="isShowRejectBecuse">
            <van-col span="24">
              <div style="color: red;margin: 2%;font-size: smaller">
                <van-icon name="warning-o" />
                <span style="margin-left: 3%;">拒绝原因: {{customer.reviewBecause }}</span>
              </div>
            </van-col>
          </van-row>
          <van-row gutter="0">
            <van-col span="24">
              <div style="color: red;margin: 2%;font-size: smaller">
                <van-icon name="warning-o" />
                <span style="margin-left: 3%;">注意: 该姓名必须与提现设置的用户名一样！否则会引起提现失败。</span>
              </div>
            </van-col>
          </van-row>
          <van-row gutter="0">
            <van-col span="24">
              <van-field
                  v-model="customer.cardId"
                  placeholder="身份证号码"
                  :rules="[{ required: true, message: '请填身份证号码' },
               { pattern: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
                message: '请输入正确身份信息',
                trigger: 'onBlur'}]"
                  :readonly="customer.isReviewPass">
              </van-field>
            </van-col>
          </van-row>
          <van-row gutter="0">
            <van-col span="24">
              <van-field name="userSex" label="性别" v-if="!customer.isReviewPass">
                <template #input>
                  <van-radio-group v-model="customer.userSex" direction="horizontal">
                    <van-radio :name="true">男</van-radio>
                    <van-radio :name="false">女</van-radio>
                  </van-radio-group>
                </template>
              </van-field>
              <van-cell v-if="customer.status">{{customer.userSex?'女':'男'}}</van-cell>
            </van-col>
          </van-row>
        </van-col>
      </van-row>
      <van-row gutter="0">
        <van-col span="24">
          <div style="min-height: 44px;line-height: 44px;color: darkgray;margin-top: 2%;font-size: smaller">
            <span style="margin-left: 5%;">手持身份证(要求：做手势动作4)</span>
          </div>
        </van-col>
      </van-row>
      <van-row gutter="0" style="background-color: white">
        <div style="margin: 2%;padding-top: 2%;">
        <van-col span="11" >
          <van-field name="holdIdCardUrl" v-if="!customer.isReviewPass">
            <template #input>
             <van-uploader accept="image/*" :max-count="1" v-model="imageOneFile" :after-read="afterImages" >
            </van-uploader>
            </template>
          </van-field>
          <van-image
              @click="perviewImage(customer.imageIdCardSelf)"
              :src="customer.imageIdCardSelf" v-if="customer.isReviewPass"></van-image>
        </van-col>
          <van-col span="2">
            <div style="padding: 16px 6px 1px;margin-left: 12px;border-left: 1px solid;font-size: 0;height: 210px;"></div>
          </van-col>
        <van-col span="11">
          <van-image
              @click="perviewImage(imageFour)"
              :src="imageFour"></van-image>
        </van-col>
        </div>
      </van-row>
      <van-row gutter="0">
        <van-col span="24">
          <div style="min-height: 44px;line-height: 44px;color: darkgray;margin-top: 2%;font-size: smaller">
            <span style="margin-left: 5%;">身份证正面</span>
          </div>
        </van-col>
      </van-row>
      <van-row gutter="0" style="background-color: white">
        <div style="margin: 2%;padding-top: 2%;">
          <van-col span="11" >
            <van-field name="IdCardUrl" v-if="!customer.isReviewPass">
              <template #input>
                <van-uploader accept="image/*" :max-count="1" v-model="imageTwoFile" :after-read="afterIdCardImages" >
                </van-uploader>
              </template>
            </van-field>
            <van-image
                @click="perviewImage(customer.imageIdCard)"
                :src="customer.imageIdCard" v-if="customer.isReviewPass"></van-image>
          </van-col>
          <van-col span="2">
            <div style="padding: 16px 6px 1px;margin-left: 12px;border-left: 1px solid;font-size: 0;height: 210px;"></div>
          </van-col>
          <van-col span="11">
            <van-image
                @click="perviewImage(imageIdCard)"
                :src="imageIdCard"></van-image>
          </van-col>
        </div>
      </van-row>
      <van-row gutter="0">
        <van-col span="24">
          <div style="min-height: 44px;line-height: 44px;color: darkgray;margin-top: 2%;font-size: smaller">
            <span style="margin-left: 5%;">身份证反面</span>
          </div>
        </van-col>
      </van-row>
      <van-row gutter="0" style="background-color: white">
        <div style="margin: 2%;padding-top: 2%;">
          <van-col span="11" >
            <van-field name="IdCardBUrl" v-if="!customer.isReviewPass">
              <template #input>
                <van-uploader accept="image/*" :max-count="1" v-model="imageThreeFile" :after-read="afterIdCardBImages" >
                </van-uploader>
              </template>
            </van-field>
            <van-image
                @click="perviewImage(customer.imageIdCardBack)"
                :src="customer.imageIdCardBack" v-if="customer.isReviewPass"></van-image>
          </van-col>
          <van-col span="2">
            <div style="padding: 16px 6px 1px;margin-left: 12px;border-left: 1px solid;font-size: 0;height: 210px;"></div>
          </van-col>
          <van-col span="11">
            <van-image
                @click="perviewImage(imageIdCardB)"
                :src="imageIdCardB"></van-image>
          </van-col>
        </div>
      </van-row>
      <div v-show="false">
      <van-row gutter="0">
        <van-col span="24">
          <div style="min-height: 44px;line-height: 44px;color: darkgray;margin-top: 2%;font-size: smaller">
            <span style="margin-left: 5%;">本人开户银行(用于验证)</span>
          </div>
        </van-col>
      </van-row>
      <van-row gutter="0" style="background-color: white">
        <van-col span="24">
          <van-field
              readonly
              clickable
              :value="customer.backName"
              placeholder="选择银行"
              @click="showPicker = true"
              is-link
              :readonly="customer.isReviewPass"
          />
          <van-popup v-model="showPicker" round position="bottom" v-if="!customer.isReviewPass">
          <van-picker
              title="选择银行"
              show-toolbar
              :columns="backInfo"
              @confirm="onConfirm"
              @cancel="onCancel"
              @change="onChange"
          />
          </van-popup>
        </van-col>
      </van-row>
      <van-row gutter="0" style="background-color: white">
        <van-col span="24">
      <van-field
          readonly
          clickable
          :value="customer.backAddr"
          placeholder="选择开户行地址"
          @click="showAddrPicker = true"
          is-link
          :readonly="customer.isReviewPass"
      />
      <van-popup v-model="showAddrPicker" round position="bottom" v-if="!customer.isReviewPass">
        <van-area
            title="选择开户行地址"
            :area-list="backAddrInfo"
            ref="myArea"
            @confirm="onAddrConfirm"
            @cancel="onAddrCancel"
            @change="onAddrChange"
        />
      </van-popup>
        </van-col>
      </van-row>
      <van-row gutter="0" style="background-color: white">
        <van-col span="24">
          <van-field
              v-model="customer.backNum"
              placeholder="银行账号"
              :rules="[{ required: true, message: '请填银行账号' }]"
              :readonly="customer.status">
          </van-field>
        </van-col>
      </van-row>
      </div>
      <van-row gutter="0" v-if="!customer.isReviewPass">
        <van-col span="24">
          <div style="min-height: 44px;line-height: 44px;color: darkgray;margin-top: 2%;font-size: smaller; text-align: center;">
            <van-button type="info" style="margin: 5%;width: 200px;" @click="onSubmit(customer)">提交审核</van-button>
          </div>
        </van-col>
      </van-row>
    </van-form>
  </div>
</template>

<script>
import {ImagePreview} from "vant";
import {MessageBox, Toast} from "mint-ui";
import {getAllB2cBackInfos, uploaderToServer, addIdCardVerifyData, getIdCardVerifyData} from "../../api/system/sys_backInfo";
import {areaList} from "@vant/area-data";
import {isStrEmpty} from "../../lib/utils";

export default {
  name: "CustomerInfo",
  data() {
    return {
      customer:{
        username:"",
        cardId:"",
        userSex:false,
        imageIdCardSelf:null,
        imageIdCard:null,
        imageIdCardBack:null,
        backName:"",
        backAddr:"",
        backNum:"",
        status:false
      },
      imageOneFile:[],
      imageTwoFile:[],
      imageThreeFile:[],
      showPicker: false,
      showAddrPicker:false,
      backInfo:[],
      backAddrInfo:areaList,
      imageFour:"https://myb2c.oss-cn-hangzhou.aliyuncs.com/admin/0-0-4.jpg",
      imageIdCard:"https://myb2c.oss-cn-hangzhou.aliyuncs.com/admin/1.jpg",
      imageIdCardB:"https://myb2c.oss-cn-hangzhou.aliyuncs.com/admin/2.jpg"
    }
  },
  computed:{
    isShowRejectBecuse(){
      return !isStrEmpty(this.customer.reviewBecause)
    }
  },
  mounted() {
    this.$emit("titleChange", "身份信息");
    getAllB2cBackInfos().then(res=>{
      if (res.success){
        this.backInfo = res.data.map(item=>item.backName);
      }
    });
    //console.log(this.backAddrInfo);
    getIdCardVerifyData().then(res=>{
      if (res.success  && res.data != null){
        this.customer = res.data;
        //this.customer.status = true;
        this.imageOneFile.push({url:this.customer.imageIdCardSelf, isImage: true});
        this.imageTwoFile.push({url:this.customer.imageIdCard, isImage: true});
        this.imageThreeFile.push({url:this.customer.imageIdCardBack, isImage: true});
      }
    }).catch(err => {
      Toast({message: err.message, type: 'error'});
    });
  },
  methods:{
    perviewImage(imgUrl){
      ImagePreview({
        images: [
          imgUrl
        ],
        closeable: true,
      });
    },
    onConfirm(value, index) {
      //Toast(`当前值：${value}, 当前索引：${index}`);
      this.customer.backName = value;
      this.showPicker = false;
    },
    onChange(picker, value, index) {
      //Toast(`当前值：${value}, 当前索引：${index}`);
      this.customer.backName = value;
      this.showPicker = false;
    },
    onCancel() {
      //Toast('取消');
      this.showPicker = false;
    },
    onAddrConfirm(value, index) {
      //Toast(`当前值：${value}, 当前索引：${index}`);
      this.customer.backAddr = value[0].name+","+value[1].name;
      this.showAddrPicker = false;
    },
    onAddrChange(picker, index, value) {
      //Toast(`当前值：${value}, 当前索引：${index}`);
      let val = picker.getValues();
      console.log(val)//查看打印
      let areaName = ''
      for (var i = 0; i < val.length; i++) {
        areaName = areaName+(i==0?'':'/')+val[i].name
      }
      this.customer.backAddr = areaName;
      this.showAddrPicker = false;
    },
    onAddrCancel() {
      //Toast('取消');
      this.showAddrPicker = false;
      this.$refs.myArea.reset()// 重置城市列表
    },
    afterImages(file){
      let tempFile = file.file;
      let type = tempFile.type;
      let size = tempFile.size;
      let newName = new Date().getTime() + tempFile.name;
      let uploadFile = new File([tempFile], newName, {type, size});
      let formData = new FormData();

      file.status = 'uploading';
      file.message = "上传中....";

      formData.append('file', uploadFile);
      uploaderToServer(formData).then(res=>{
        if (res.success){
          file.status = 'success';
          file.message = '上传成功';
          this.customer.imageIdCardSelf = res.data;
        }
      });
    },
    afterIdCardImages(file){
      let tempFile = file.file;
      let type = tempFile.type;
      let size = tempFile.size;
      let newName = new Date().getTime() + tempFile.name;
      let uploadFile = new File([tempFile], newName, {type, size});
      let formData = new FormData();

      file.status = 'uploading';
      file.message = "上传中....";

      formData.append('file', uploadFile);
      uploaderToServer(formData).then(res=>{
        if (res.success){
          file.status = 'success';
          file.message = '上传成功';
          this.customer.imageIdCard = res.data;
        }
      });
    },
    afterIdCardBImages(file){
      let tempFile = file.file;
      let type = tempFile.type;
      let size = tempFile.size;
      let newName = new Date().getTime() + tempFile.name;
      let uploadFile = new File([tempFile], newName, {type, size});
      let formData = new FormData();

      file.status = 'uploading';
      file.message = "上传中....";

      formData.append('file', uploadFile);
      uploaderToServer(formData).then(res=>{
        if (res.success){
          file.status = 'success';
          file.message = '上传成功';
          this.customer.imageIdCardBack = res.data;
        }
      });
    },
    onSubmit(values){
      console.log(values);
      if (isStrEmpty(values.cardId)
          ||isStrEmpty(values.username)
          ||isStrEmpty(values.imageIdCardSelf)
          || isStrEmpty(values.imageIdCard)
          || isStrEmpty(values.imageIdCardBack)){
        MessageBox({
          title: '提示',
          message: "确保上传身份图片, 姓名和正确的身份证信息",
          showCancelButton: true
        });
      }else{
        addIdCardVerifyData(values).then(res=>{
          if (res.success){
            Toast({message: res.data, type: 'success'});
            this.$router.back();
          }
        }).catch(err => {
          Toast({message: err.message, type: 'error'});
        });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .van-uploader__upload{
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  box-sizing: border-box;
  width: 128px;
  height: 225px;
  margin: 0 8px 8px 0;
  background-color: #f7f8fa;
}

::v-deep .van-uploader__preview-image{
  display: block;
  width: 128px;
  height: 225px;
  overflow: hidden;
}
</style>
